var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 17.5,
    fill: "white",
    stroke: "#FF7A00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 16L17.06 18.06L15 19L17.06 19.94L18 22L18.94 19.94L21 19L18.94 18.06L18 16ZM26 11H22.83L21 9H15L13.17 11H10C8.9 11 8 11.9 8 13V25C8 26.1 8.9 27 10 27H26C27.1 27 28 26.1 28 25V13C28 11.9 27.1 11 26 11ZM26 25H10V13H14.05L14.64 12.35L15.88 11H20.12L21.36 12.35L21.95 13H26V25ZM18 14C15.24 14 13 16.24 13 19C13 21.76 15.24 24 18 24C20.76 24 23 21.76 23 19C23 16.24 20.76 14 18 14ZM18 22C16.35 22 15 20.65 15 19C15 17.35 16.35 16 18 16C19.65 16 21 17.35 21 19C21 20.65 19.65 22 18 22Z",
    fill: "#FF7A00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.1e39ca6cf76c3ad7400ba44b168024df.svg";
export { ForwardRef as ReactComponent };